var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.51 38.5",
    id: "facebook",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 38.51,
    y1: 19.25,
    y2: 19.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1677f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#176ee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#1d55d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#252eb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b189c"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M38.51,19.25c0,5.29-2.17,10.11-5.66,13.6-3.27,3.27-7.71,5.37-12.6,5.62-.33.02-.67.03-1,.03C8.66,38.5,0,29.84,0,19.25c0-5.29,2.16-10.11,5.65-13.6S13.96,0,19.25,0s10.11,2.16,13.6,5.65c3.02,3.02,5.05,7.04,5.54,11.5.08.69.12,1.39.12,2.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2921a4",
    d: "M38.51,19.25c0,5.29-2.17,10.11-5.66,13.6-3.27,3.27-7.71,5.37-12.6,5.62-1.03-1.09-2.08-2.2-2.87-3.03-.8-.85-1.34-1.42-1.34-1.42v-7.95l-4.7-4.97v-5.35h4.7c4.14-6.98,4.24-9.73,11.12-10.91,0,0,9.55,10.54,11.23,12.31.08.69.12,1.39.12,2.1Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.82,34.02v-12.92h4.31l.82-5.35h-5.13v-3.47c0-1.46.72-2.89,3.01-2.89h2.33v-4.55s-2.12-.36-4.14-.36c-4.22,0-6.98,2.56-6.98,7.19v4.07h-4.7v5.35h4.7v12.92h5.78Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5986535b76f1bfd3ccf1ab48d25b1958.svg";
export { ForwardRef as ReactComponent };